import IMask from 'imask';
export var IMASK_DATE_INPUT_OPTIONS = {
  mask: Date,
  pattern: 'd{.}`m{.}`Y',
  blocks: {
    d: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2,
      placeholderChar: 'д'
    },
    m: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2,
      placeholderChar: 'м'
    },
    Y: {
      maxLength: 4,
      mask: IMask.MaskedRange,
      from: 1000,
      to: 2999,
      placeholderChar: 'г'
    }
  },
  lazy: false,
  overwrite: true,
  autofix: false
};